import config from 'utils/apiconfig';
import request from 'utils/request';

const { api } = config;
const { publicBoard, publicBoardId } = api;

/**
 * 查询河流列表
 */
export async function list(params) {
  return request({ url: publicBoard, method: 'get', data: params, });
}
/**
 * 查询河流详情
 */
export async function getDetail(paramId) {
  return request({
    url: publicBoardId, method: 'get', data: {
      id: paramId
    },
  });
}
/**
 * 编辑河流
 */
export async function edit(params) {
  return request({ url: publicBoardId, method: 'put', data: params });
}
/**
 * 删除河流
 */
export async function deleteItem(params) {
  return request({ url: publicBoard+ '/delete' , method: 'post', data: params });
}
/**
 * 创建河流
 */
export async function createItem(params) {
  return request({ url: publicBoard, method: 'post', data: params, });
}
